import styled from 'styled-components';

export const Svg = styled.svg`
  cursor: grab;
  min-width: 16px;
  width: 16px;
`;
